<template>
    <sa-page-layout :showModalLoading="showModalLoading" :pathResource="pathResource" :linkedit="pathResource">
        <template slot="toolbar-title">Identity Server Manager</template>
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovoIdentityManager">
                <b-icon icon="plus"> </b-icon>
                Nuovo
            </b-button>
        </template>

        <template slot="table-filter">
            <b-form>
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="9" lg="9" xl="9">
                        <label class="sa-label-data">Nome Applicativo</label>
                        <b-form-input v-model="filtro.applicationName" type="search" placeholder="Nome Applicativo"></b-form-input>
                    </b-col>

                    <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                        <label class="sa-label-data">OTP</label>
                        <b-form-select :options="otpOptions" v-model="filtro.otp" type="search" value-field="value" text-field="text">
                            <template #first>
                                <b-form-select-option :value="null"> - Selezionare OTP - </b-form-select-option>
                            </template>
                        </b-form-select>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" @click="onSubmit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>

        <template slot="table-body">
            <identity-manager-list-component ref="cmpIdentityManagerList" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/layout/components/SaPageLayout.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import IdentityManagerListComponent from "../components/IdentityManagerListComponent.vue";
export default {
    components: { SaPageLayout, IdentityManagerListComponent },
    mixins: { UtilityMixin },
    data() {
        return {
            pathResource: "/identitymanager",
            items: [],
            rows: 0,
            perPage: 1,
            currentPage: 1,
            filtro: { forPage: this.perPage, page: this.currentPage, otp: null, applicationName: null },
            listKey: 0,
            showModalLoading: false,
            fields: [
                {
                    label: "*",
                    key: "index",
                },
                {
                    label: "Piano",
                    key: "nomePiano",
                    sortable: true,
                    thStyle: "width: 18rem",
                },
                {
                    label: "",
                    class: "sa-table-column-action-double",
                    key: "actions",
                },
            ],
            otpOptions: [
                { value: "SI", text: "SI" },
                { value: "NO", text: "NO" },
            ],
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        loadData() {
            let me = this;
            me.$refs.cmpIdentityManagerList.loadDataIdentityManager();
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroIdentity"] = JSON.stringify(me.filtro);
            me.loadData();
        },
        onReset() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroIdentity"] = JSON.stringify((me.filtro = { forPage: me.forPage, page: me.currentPage, otp: null, applicationName: null }));
            me.loadData();
        },

        onClickNuovoIdentityManager() {
            let me = this;
            me.$refs.cmpIdentityManagerList.onClickNuovoIdentity();
        },
    },
};
</script>

<style></style>
